import script from "./ExportConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportConfig.vue?vue&type=script&setup=true&lang=js"

import "./ExportConfig.vue?vue&type=style&index=0&id=da319952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da319952"]])

export default __exports__